import './style.scss';
import DataUrlHelper from '../../../../helpers/data-url.helper';

interface ISelectableSquareProps {
  icon: string;
  title: string;
  name: string;
  className: string;
  text: string;
  checked: boolean;
  onChange?: () => void;
}

 
function SelectableSquare({ icon, title, name, className, text, checked, onChange }: ISelectableSquareProps) {
  return (
    <label className={`selectable-square ${className} d-flex flex-fill align-items-center rounded w-100 mb-0`}>
      <input type="radio" name={name} onChange={onChange} checked={checked} className="selectable-square__input position-absolute" />
      <img src={DataUrlHelper.encode(icon)} alt="" />
      <span className="h3 mb-0">{title ?? ''}</span>
      <span className="text-center fw-normal">{text}</span>
    </label>
  );
}

export default SelectableSquare;
